import { useRef } from "react";
import { getServerContext } from "../vite/one-server-only";
import { getQueryKey } from "./getQueryKey";
import { useQuery as useQuery$1 } from "./useQueryZero";

var _getServerContext;
var clientInitialData = (_getServerContext = getServerContext()) === null || _getServerContext === void 0 ? void 0 : _getServerContext.postRenderData;
globalThis["__vxrnServerData__"] = {};
var useQuery = function(query) {
	var snapshot = useQuery$1(query, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true);
	var queryIdRef = useRef(void 0);
	if (query && !queryIdRef.current) queryIdRef.current = getQueryKey(query);
	var queryId = queryIdRef.current || "";
	if (clientInitialData && !snapshot) return clientInitialData[queryId] || [];
	return snapshot || [];
};

export { useQuery };